import { all, fork } from 'redux-saga/effects';
import { watchAdminAuth } from './adminAuthSaga';
import { watchClientRequests } from './clientSaga';
import { watchPartnerRequests } from './partnerSaga';
import { watchEmailManagementRequests } from './emailManagementSaga';
import { watchSmsManagementRequests } from './smsManagementSaga';
import { watchMailingListRequests } from './mailingListSaga';

// Sagas par section métier
import { watchTripsRequests } from './tripsSaga';
import { watchForecastsRequests } from './forecastsSaga';
import { watchClaimsRequests } from './claimsSaga';
import { watchPoliciesRequests } from './policiesSaga';
import { watchActivitiesRequests } from './activitiesSaga';
import { watchActivitiesManagementRequests } from './activitiesManagementSaga';
import { watchActivityReferencesRequests } from './activityReferencesSaga';
import { watchActivitySubcoveragesRequests } from './activitySubcoveragesSaga';
import { watchStatisticsRequests } from './statisticsSaga';

/**
 * Root Saga - Centralise toutes les sagas de l'application
 * Organisé par sections métier pour une meilleure maintenabilité
 */
export default function* rootSaga() {
    yield all([
        // Authentification
        fork(watchAdminAuth),

        // Gestion des entités principales
        fork(watchClientRequests),
        fork(watchPartnerRequests),
        fork(watchEmailManagementRequests),
        fork(watchSmsManagementRequests),
        fork(watchMailingListRequests),

        // Section Trips (Séjours)
        fork(watchTripsRequests),

        // Section Activity (Activités)
        fork(watchForecastsRequests),
        fork(watchClaimsRequests),
        fork(watchPoliciesRequests),
        fork(watchActivitiesRequests),
        fork(watchActivitiesManagementRequests),
        fork(watchActivityReferencesRequests),
        fork(watchActivitySubcoveragesRequests),

        // Statistiques
        fork(watchStatisticsRequests),
    ]);
}

